import { render, staticRenderFns } from "./CompanyNewsItem.vue?vue&type=template&id=bde8803c&scoped=true"
import script from "./CompanyNewsItem.vue?vue&type=script&lang=js"
export * from "./CompanyNewsItem.vue?vue&type=script&lang=js"
import style0 from "./CompanyNewsItem.vue?vue&type=style&index=0&id=bde8803c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde8803c",
  null
  
)

export default component.exports